var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReprtInact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_52_34)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.37 17.7H2.88C1.29 17.7 0 16.41 0 14.82V2.88C0 1.29 1.29 0 2.88 0H11.37C12.96 0 14.25 1.29 14.25 2.88V14.82C14.25 16.41 12.96 17.7 11.37 17.7ZM2.88 0.98C1.83 0.98 0.97 1.84 0.97 2.89V14.83C0.97 15.88 1.83 16.74 2.88 16.74H11.37C12.42 16.74 13.28 15.88 13.28 14.83V2.88C13.28 1.83 12.42 0.97 11.37 0.97H2.88V0.98Z",
    fill: "#33363F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.12999 10.05C4.92999 10.05 3.14999 8.26003 3.14999 6.07003C3.14999 3.88003 4.93999 2.09003 7.12999 2.09003C9.31999 2.09003 11.11 3.88003 11.11 6.07003C11.11 8.26003 9.31999 10.05 7.12999 10.05ZM7.12999 3.06003C5.46999 3.06003 4.11999 4.41003 4.11999 6.07003C4.11999 7.73003 5.46999 9.08003 7.12999 9.08003C8.78999 9.08003 10.14 7.73003 10.14 6.07003C10.14 4.41003 8.78999 3.06003 7.12999 3.06003Z",
    fill: "#33363F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25001 8.88001L6.64001 6.27001V2.57001H7.61001V5.86001L9.94001 8.19001L9.25001 8.88001Z",
    fill: "#33363F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.74 12.16H2.50999C2.23999 12.16 2.01999 11.94 2.01999 11.67C2.01999 11.4 2.23999 11.18 2.50999 11.18H11.74C12.01 11.18 12.23 11.4 12.23 11.67C12.23 11.94 12.01 12.16 11.74 12.16Z",
    fill: "#33363F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.43999 14.39H2.50999C2.23999 14.39 2.01999 14.17 2.01999 13.9C2.01999 13.63 2.23999 13.41 2.50999 13.41H7.43999C7.70999 13.41 7.92999 13.63 7.92999 13.9C7.92999 14.17 7.70999 14.39 7.43999 14.39Z",
    fill: "#33363F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_52_34"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.25,
    height: 17.7,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReprtInact);
export default __webpack_public_path__ + "static/media/Reprt Inact.afcc375acae008d2970a4f59ec6edeba.svg";
export { ForwardRef as ReactComponent };